﻿import { peek } from './overview-filters';
import {setBadges} from "./overview-filter-badge";
import {appendSearchParam, deleteSearchParam, getSearchParams, multiChoiceFilters} from "./overview-filter-state";
import { attributes } from "./overview-filter-constants";

const findInput = (filter, key) => {
	let result = undefined;
	const inputs = findFilterInputs(filter);

	inputs.forEach(input => {
		if (input.value === key) {
			result = input;
		}
	});

	return result;
}

const findFilterInputs = (name) => {
	return document.querySelectorAll(`input[${attributes.filterName}=${name}][${attributes.filterMultiChoice}]`);
}

const handleMultiChoiceChange = async (event) => {
	const target = event.target;
	const name = target.name;
	const value = target.value;
	const checked = target.checked;

	if(checked)
		appendSearchParam(name, value);
	else
		deleteSearchParam(name, value);

	updateMultiChoiceBadge(name);
	await peek();
}

const bindMultiChoiceEdit = (...filters) => {
	filters.forEach(filter => {
		const boxes = findFilterInputs(filter);
		boxes.forEach(box => box.addEventListener("change", handleMultiChoiceChange));
	});
}

const setVacancyCounter = (input, value) => {
	const label = document.querySelector(`label[for=${input.id}] span[${attributes.filterMultiChoiceCounter}]`);
	if (label)
		label.innerHTML = value;
}

export const bindMultiChoiceGroup = (...filters) => {
	bindMultiChoiceEdit(...filters);
}

export const clearMultiChoiceInputs = () => {
	for (const filter in multiChoiceFilters) {
		const options = findFilterInputs(multiChoiceFilters[filter]);
		options.forEach(input => { input.checked = false; })
		for (const filter in multiChoiceFilters) {
			updateMultiChoiceBadge(multiChoiceFilters[filter]);
		}
	}
}

export const setMultiChoiceFromParams = () => {
	const params = getSearchParams();

	for(const filter in multiChoiceFilters) {
		const options = findFilterInputs(multiChoiceFilters[filter]);
		options.forEach(x => {
			x.checked = params.has(multiChoiceFilters[filter], x.value);
		});
	}
}

export const updateMultiChoiceCounts = (filterData) => {
	for (const filter in multiChoiceFilters)
	{
		const options = filterData.find(x => x.key === multiChoiceFilters[filter]).options;
		options.forEach(({key, numberOfResults}) => {
			const input = findInput(multiChoiceFilters[filter], key);

			setVacancyCounter(input, numberOfResults);
		});
	}
}

export const anyMultiChoiceFilters = () => {
	for (const filter in multiChoiceFilters)
	{
		if(document.querySelectorAll(`[${attributes.filterPopup}="${multiChoiceFilters[filter]}"] input:checked`).length > 0)
			return true;
	}

	return false;
}

export const updateMultiChoiceBadge = (filter) => {
	const popup = document.querySelector(`[${attributes.filterPopup}="${filter}"]`);

	if(popup) {
		const count = popup.querySelectorAll(":checked").length;
		setBadges(filter, count);
	}
}

